import { FormattedNumber as OriginalFormattedNumber } from "react-intl";
import { isSomething } from "../../utils";
import { rulesShape, withRules } from "../../context";

type Props = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  value?: number;
  rules: rulesShape;
};

export function FormattedNumber(props: Props) {
  const { minimumFractionDigits, maximumFractionDigits, value, rules } = props;

  const min =
    minimumFractionDigits || rules.application().get("minDecimalDigits");
  const max =
    maximumFractionDigits || rules.application().get("maxDecimalDigits");

  return isSomething(value) ? (
    <OriginalFormattedNumber
      {...props}
      minimumFractionDigits={min}
      maximumFractionDigits={max}
      // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
      value={value}
    />
  ) : (
    <span>-</span>
  );
}

export default withRules(FormattedNumber);
